// extracted by mini-css-extract-plugin
export default {"input":"search_input__lc1BW","label":"search_label__r6Evl"};